import { ComponentProps } from "react"
import { cn } from "cn"

import { Link } from "@/components/ui/link"

export function RegistrationTermsDisclaimer({
  className,
  ...props
}: ComponentProps<"div">) {
  return (
    <div
      className={cn("text-center text-2xs text-muted", className)}
      {...props}
    >
      By continuing, you agree to Mindtrip’s{" "}
      <Link
        href="/terms-of-service"
        className="font-medium text-foreground underline"
        target="_blank"
      >
        Terms of Service
      </Link>{" "}
      and acknowledge you’ve read our{" "}
      <Link
        href="/privacy-policy"
        className="font-medium text-foreground underline"
        target="_blank"
      >
        Privacy Policy
      </Link>
      .
    </div>
  )
}
